<div class="save-button">
    <button aria-live="polite" [ngClass]="{'disabled' : disabled}" [disabled]="(enable$ | async) !== true" (click)="saveQuestionSet()">
        <span>Next</span>
    </button>
</div>